import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaicabservice() {



    const cardData = {





keyword: "Mumbai Cab Service",

headingDescription: "Shreesha Tours & Travels provides reliable and affordable Mumbai Cab Service for local travel, airport transfers, railway station pickup and drop, corporate transportation, business meetings, family outings, sightseeing tours, one-way trips, round trips, and outstation journeys across Maharashtra and India. We offer a wide range of chauffeur-driven vehicles including Sedan, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUV, Tempo Traveller, Urbania, Mini Bus, and luxury cars to meet every travel requirement. With experienced drivers, clean and well-maintained vehicles, transparent pricing, doorstep pickup, flexible booking options, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, comfortable, and hassle-free travel experience. Whether you need a cab for airport transfers, corporate travel, family vacations, wedding transportation, pilgrimage tours, or long-distance trips, our professional taxi services in Mumbai provide punctual service and complete customer satisfaction.",

topPlaces: [
  {
    title: "Mumbai to Elephanta Caves",
    description: "Elephanta Caves are a UNESCO World Heritage Site famous for ancient rock-cut sculptures dedicated to Lord Shiva. It is a popular destination for history lovers and tourists exploring Mumbai."
  },
  {
    title: "Mumbai to Kanheri Caves",
    description: "Kanheri Caves located inside Sanjay Gandhi National Park are known for ancient Buddhist caves, sculptures, and peaceful natural surroundings. It is an excellent destination for heritage and nature lovers."
  },
  {
    title: "Mumbai to Sanjay Gandhi National Park",
    description: "Sanjay Gandhi National Park is a green escape within Mumbai, famous for wildlife, trekking trails, Kanheri Caves, and scenic landscapes. It is ideal for family outings and weekend visits."
  },
  {
    title: "Mumbai to EsselWorld",
    description: "EsselWorld is one of India's famous amusement parks offering thrilling rides, entertainment, and fun activities for families, children, and groups."
  },
  {
    title: "Mumbai to Imagica",
    description: "Imagica is a popular theme park near Mumbai offering exciting rides, entertainment zones, water attractions, and family-friendly experiences for visitors of all ages."
  },
  {
    title: "Mumbai to Matheran",
    description: "Matheran is a peaceful hill station near Mumbai known for scenic viewpoints, toy train rides, forests, and a pollution-free environment. It is a perfect weekend getaway destination."
  },
  {
    title: "Mumbai to Alibaug",
    description: "Alibaug is a beautiful coastal destination famous for beaches, forts, resorts, and water activities. It is one of the most preferred weekend destinations from Mumbai."
  },
  {
    title: "Mumbai to Lonavala",
    description: "Lonavala is a popular hill station known for waterfalls, caves, viewpoints, and green valleys. It attracts families, couples, and groups throughout the year."
  },
  {
    title: "Mumbai to Nashik",
    description: "Nashik is famous for Trimbakeshwar Jyotirlinga, vineyards, temples, and scenic surroundings. It is a preferred destination for religious tours and weekend trips."
  },
  {
    title: "Mumbai to Mahabaleshwar",
    description: "Mahabaleshwar is a beautiful hill station known for Venna Lake, strawberry farms, viewpoints, and pleasant weather. It is an ideal destination for family holidays and nature trips."
  }
],




"services": [
  {
    "name": "Mumbai Cab Service",
    "description": "Book Mumbai Cab Service for safe, comfortable, and reliable transportation across the city and nearby destinations. Get professional chauffeur-driven cars for local travel, airport transfers, corporate meetings, family trips, sightseeing, and outstation journeys with Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cab options."
  },
  {
    "name": "Mumbai to Shirdi Cab",
    "description": "Choose Mumbai to Shirdi Cab for a comfortable and hassle-free pilgrimage journey with experienced drivers and well-maintained AC vehicles. Enjoy convenient pickup, flexible one way and round trip options, and reliable cab services for Sai Baba Darshan with family and groups."
  },
  {
    "name": "Cab from Pune to Mumbai",
    "description": "Book Cab from Pune to Mumbai for smooth intercity travel with professional chauffeurs, clean vehicles, and affordable fares. Ideal for airport transfers, business travel, family trips, and one way journeys between Pune and Mumbai with comfortable travel options."
  },
  {
    "name": "Cab Booking Mumbai",
    "description": "Complete Cab Booking Mumbai with quick confirmation, affordable pricing, and multiple vehicle choices. Enjoy convenient online booking for local rides, airport transfers, corporate travel, sightseeing tours, and outstation trips with reliable chauffeur service."
  },
  {
    "name": "Mumbai to Shirdi Taxi",
    "description": "Hire Mumbai to Shirdi Taxi for safe and comfortable religious travel with experienced drivers and premium vehicles. Perfect for temple visits, family pilgrimages, and weekend trips with Sedan, Ertiga, Innova, and SUV cab options."
  },
  {
    "name": "Cheapest Cab Service in Mumbai",
    "description": "Choose Cheapest Cab Service in Mumbai for budget-friendly travel without compromising comfort and safety. Get affordable taxi solutions for local travel, airport transfers, business trips, family outings, and outstation journeys with transparent fares."
  },
  {
    "name": "Best Cab Service in Mumbai",
    "description": "Book the Best Cab Service in Mumbai for reliable transportation with professional chauffeurs, clean AC vehicles, and excellent customer support. Whether you need airport pickup, local sightseeing, corporate travel, family trips, or long-distance cab services, enjoy a comfortable and stress-free journey."
  },
  {
    "name": "Mumbai to Vadodara Taxi",
    "description": "Reserve Mumbai to Vadodara Taxi for comfortable interstate travel with skilled drivers and well-maintained vehicles. Enjoy reliable one way and round trip taxi services with affordable pricing for business trips, family travel, and personal journeys."
  },
  {
    "name": "Airport Taxi Mumbai",
    "description": "Book Airport Taxi Mumbai for timely airport pickup and drop services with professional chauffeurs and clean vehicles. Get reliable transportation to and from Mumbai International Airport with luggage assistance and 24x7 availability."
  },
  {
    "name": "Outstation Cabs Mumbai",
    "description": "Choose Outstation Cabs Mumbai for safe and comfortable long-distance travel across Maharashtra and India. Travel with experienced drivers, spacious AC vehicles, and flexible one way or round trip options for family holidays, corporate trips, and weekend getaways."
  },
  {
    "name": "Mumbai to Vadodara Cab",
    "description": "Book Mumbai to Vadodara Cab for smooth and convenient road travel with premium vehicles and professional chauffeurs. Enjoy comfortable interstate transportation with Sedan, SUV, Innova, and luxury cab options for personal and business travel."
  },
  {
    "name": "Mumbai to Goa Car Rentals",
    "description": "Choose Mumbai to Goa Car Rentals for comfortable holiday travel with chauffeur-driven vehicles and flexible rental packages. Enjoy safe road trips from Mumbai to Goa with spacious cars, experienced drivers, and options suitable for families, couples, and groups."
  }
],
"tableData": [
  ["Mumbai Cab Service", "Mumbai to Shirdi Cab"],
  ["Cab from Pune to Mumbai", "Cab Booking Mumbai"],
  ["Mumbai to Shirdi Taxi", "Cheapest Cab Service in Mumbai"],
  ["Best Cab Service in Mumbai", "Mumbai to Vadodara Taxi"],
  ["Airport Taxi Mumbai", "Outstation Cabs Mumbai"],
  ["Mumbai to Vadodara Cab", "Mumbai to Goa Car Rentals"]
],




whychoose: [
  {
    WhyChooseheading: "Trusted Mumbai Cab Service for Every Journey",
    WhyChoosedescription: "Shreesha Travels provides reliable cab services in Mumbai for local travel, airport transfers, corporate transportation, family trips, sightseeing, and outstation journeys. Our chauffeur-driven cars ensure a comfortable and convenient travel experience across the city and beyond."
  },
  {
    WhyChooseheading: "Easy Travel Across Mumbai City",
    WhyChoosedescription: "From business districts and residential areas to airports, railway stations, hotels, and tourist attractions, our Mumbai cabs provide smooth connectivity with timely pickup and drop services."
  },
  {
    WhyChooseheading: "Cars Available for Every Travel Requirement",
    WhyChoosedescription: "Select from a wide range of vehicles including Hatchbacks, Swift Dzire, Sedan Cars, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    WhyChooseheading: "Perfect for Airport, Corporate & Personal Travel",
    WhyChoosedescription: "Our cab services are suitable for Mumbai Airport transfers, office meetings, hotel pickups, client visits, shopping trips, family outings, events, and daily transportation needs."
  },
  {
    WhyChooseheading: "Local & Outstation Cab Booking Options",
    WhyChoosedescription: "Along with Mumbai city rides, we offer one-way cabs, round trips, and outstation taxi services from Mumbai to Pune, Goa, Nashik, Shirdi, Lonavala, Mahabaleshwar, and destinations across India."
  },
  {
    WhyChooseheading: "Professional Drivers for Safe Travel",
    WhyChoosedescription: "Our experienced chauffeurs understand Mumbai routes, traffic patterns, and major destinations, ensuring safe driving, punctual service, and a hassle-free journey."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Cab Fleet",
    WhyChoosedescription: "Every vehicle is regularly serviced, cleaned, air-conditioned, and inspected before trips to provide passengers with a comfortable and dependable ride."
  },
  {
    WhyChooseheading: "Book Mumbai Cab Service with Shreesha Travels",
    WhyChoosedescription: "Enjoy quick booking support, transparent pricing, flexible travel options, and reliable transportation solutions for all your Mumbai travel requirements."
  }
]

};

const faqData = [
  {
    question: "What types of cabs are available in Mumbai?",
    answer: "We provide various options including Hatchbacks, Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, and larger group vehicles."
  },
  {
    question: "Do you provide Mumbai Airport cab services?",
    answer: "Yes, we offer airport pickup and drop services for both domestic and international terminals at Mumbai Airport."
  },
  {
    question: "Can I book a cab for local Mumbai sightseeing?",
    answer: "Yes, cabs are available for Mumbai Darshan, tourist places, shopping areas, hotels, and customized city tours."
  },
  {
    question: "Are Mumbai cabs available for corporate travel?",
    answer: "Yes, our services support corporate meetings, employee transportation, client visits, conferences, and official travel requirements."
  },
  {
    question: "Can I book a Mumbai cab for outstation trips?",
    answer: "Yes, we provide outstation taxi services from Mumbai to destinations across Maharashtra and other states."
  },
  {
    question: "Is one-way cab booking available in Mumbai?",
    answer: "Yes, one-way cab services are available for airport transfers, intercity travel, and direct destination drops."
  },
  {
    question: "Can I hire a cab for weddings and events?",
    answer: "Yes, our vehicles are available for weddings, family functions, guest transportation, and special events."
  },
  {
    question: "How is the Mumbai cab fare calculated?",
    answer: "The fare depends on the vehicle type, travel distance, trip duration, route, and selected service package."
  },
  {
    question: "Can I book a cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability during weekends, holidays, and peak travel periods."
  },
  {
    question: "How can I book Mumbai Cab Service with Shreesha Travels?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Kapoor",
    feedback: "The cab service was punctual, comfortable, and professionally managed. The driver knew the routes well and made travelling across Mumbai very convenient.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Shah",
    feedback: "Excellent experience with a clean vehicle and smooth coordination. The booking process was simple, and the overall journey was comfortable and stress-free.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Cab Service",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-cab-service.webp",
  "description":
    "Book Mumbai Cab Service with Shreesha Tours & Travels for safe, comfortable, and affordable local and outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for airport transfers, city travel, Mumbai to Shirdi trips, Pune to Mumbai transfers, corporate travel, family journeys, and long-distance outstation routes.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-cab-service"
  }
};






    return (
        <div>
<Helmet>
  <title>Mumbai Cab Service | Online Taxi Booking | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai Cab Service with Shreesha Travels for reliable local, airport, and outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for Mumbai to Shirdi, Pune to Mumbai, and other routes with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai Cab Service, Mumbai Cab Booking, Mumbai Taxi Service, Mumbai to Shirdi Cab, Cab from Pune to Mumbai, Pune to Mumbai Cab Booking, Mumbai Local Cab, Mumbai Airport Cab Service, Mumbai Outstation Cab, Mumbai One Way Taxi, Mumbai Round Trip Cab, Online Cab Booking Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/62.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaicabservice;